import React from 'react';
import Skeleton from 'react-loading-skeleton';

const StoppedAvtalegiroFormSkeleton: React.FC = () => {
    return (
        <form className="stopped-avtalegiro-form">
            <div className="transaction-details__receiver">
                <span className="sgw-label info--small">
                    <Skeleton height={24} width={60} />
                </span>
                <div className="transaction-details__receiver-amount-wrapper">
                    <span className="transaction-details__receiver-amount">
                        <Skeleton height={60} width={200} />
                    </span>
                </div>
            </div>
            <Skeleton className="stopped-payment__details-error-message" height={45} width="100%" />
            <div className="select-list__container stopped-avtalegiro-form__select-list">
                <li>
                    <button type="button" className="row-button__container" disabled>
                        <div className="account-selector-layout__container">
                            <span className="account-selector-layout__first-row">
                                <span className="account-selector-layout__label">Fra</span>
                                <span className="account-selector-layout__extra-label" />
                            </span>
                            <span className="account-selector-layout__second-row">
                                <span className="account-selector-layout__alias">
                                    <Skeleton height={16} width={100} />
                                </span>
                                <span className="account-selector-layout__value">
                                    <Skeleton height={16} width={40} />
                                </span>
                            </span>
                            <span className="account-selector-layout__third-row">
                                <span className="account-selector-layout__account-number">
                                    <Skeleton height={16} width={40} />
                                </span>
                                <span className="account-selector-layout__credit" />
                            </span>
                        </div>
                    </button>
                </li>
                <li>
                    <button type="button" className="row-button__container" disabled>
                        <div className="receiver-account-error-label">Til</div>
                        <div className="account-selector-layout__container">
                            <span className="account-selector-layout__first-row">
                                <span className="account-selector-layout__label" />
                                <span className="account-selector-layout__extra-label" />
                            </span>
                            <span className="account-selector-layout__second-row">
                                <span className="account-selector-layout__alias">
                                    <Skeleton height={16} width={110} />
                                </span>
                                <span className="account-selector-layout__value" />
                            </span>
                            <span className="account-selector-layout__third-row">
                                <span className="account-selector-layout__account-number">
                                    <Skeleton height={16} width={40} />
                                </span>
                                <span className="account-selector-layout__credit" />
                            </span>
                        </div>
                    </button>
                </li>
                <li>
                    <button type="button" className="row-button__container kid-field__row-btn" disabled>
                        <div className="note-field-layout__container">
                            <div className="note-field-container">
                                <div className="note-field-layout__label">KID</div>
                                <div className="note-field-layout__note">
                                    <Skeleton height={16} width={40} />
                                </div>
                            </div>
                        </div>
                    </button>
                </li>
                <li>
                    <button type="button" className="row-button__container note-field__row-btn" disabled>
                        <div className="note-field-layout__container">
                            <div className="note-field-container">
                                <div className="note-field-layout__label">Legg til eget notat</div>
                                <div className="note-field-layout__note">
                                    <Skeleton height={16} width={40} />
                                </div>
                            </div>
                        </div>
                    </button>
                </li>
                <li>
                    <button type="button" className="row-button__container amount-limit-field__row-btn" disabled>
                        <div className="note-field-layout__container">
                            <div className="note-field-container">
                                <div className="note-field-layout__label">Maksbeløp per betaling</div>
                                <div className="note-field-layout__note">
                                    <Skeleton height={16} width={40} />
                                </div>
                            </div>
                        </div>
                    </button>
                </li>
                <li>
                    <button type="button" className="row-button__container amount-limit-field__row-btn" disabled>
                        <div className="note-field-layout__container">
                            <div className="note-field-container">
                                <div className="note-field-layout__label">Månedlig maksbeløp</div>
                                <div className="note-field-layout__note">
                                    <Skeleton height={16} width={40} />
                                </div>
                            </div>
                        </div>
                    </button>
                </li>
            </div>
            <div className="transaction-form__submit avtalegiro__footer" />
        </form>
    );
};

export default StoppedAvtalegiroFormSkeleton;
